<template>
<span>
    <!--<mdb-card-group deck>-->
        <mdb-row>
            <mdb-col  lg="6"  v-for="(el,ky) in main_content" :key="ky" class="mb-3">
                <mdb-card class="card-image" :style="'background-color: '" >
                    <mdb-view hover>
                        <a href="#!">                            
                            <mdb-mask flex-center waves overlay="white-slight"></mdb-mask>
                        </a>
                    </mdb-view>
                    <mdb-card-body class="back-light text-white">
                        <mdb-card-title v-html="el['heading']"></mdb-card-title>
                        <mdb-card-text class="text-white" >
                            <mdb-list-group class=""> 
                    
                                <router-link :to="'/content/'+content['id_cr']" v-for="(content,k) in el['content']" :key="k">
                                    <mdb-list-group-item class="text-left" :action="true"  v-html="content['title']"></mdb-list-group-item>
                                </router-link>
                                
                            </mdb-list-group>
                        </mdb-card-text>

                    </mdb-card-body>
                    <mdb-card-footer class="text-muted back-light text-right " >
                        <span class="text-white">{{el['count']+' '+el['found']}}  </span><mdb-btn v-if="el['view']" mt-auto color="primary" class="mt-0 mb-0 ">{{el['view']}}</mdb-btn>
                    </mdb-card-footer>	
                </mdb-card>
            </mdb-col>
        </mdb-row>
    <!--</mdb-card-group>-->
</span>
</template>

<script>
import axios from 'axios';
import { mdbRow, mdbCol,mdbCard, mdbCardHeader, mdbCardBody, mdbCardTitle, mdbCardText, mdbCardFooter, mdbCardUp, mdbCardAvatar, mdbCardGroup, mdbBtn, mdbView, mdbMask, mdbIcon, mdbListGroup, mdbListGroupItem } from 'mdbvue';
export default {
    name: 'mainContent',
    data(){
        return{
            main_content:[],
            CONTENT_DOMAIN:this.$store.state.CONTENT_DOMAIN            
        };        
    },
    components:{
        mdbCard, mdbCardHeader, mdbCardBody, mdbCardTitle, mdbCardText, mdbCardFooter, 
        mdbCardUp, mdbCardAvatar, mdbCardGroup, mdbBtn, mdbView, mdbMask, mdbIcon,
        mdbRow,mdbCol,mdbListGroup, mdbListGroupItem
    },
    created :function(){
        this.showContent()
    },
    watch: {
        // call again the method if the route changes
        '$route': 'showContent'
    },
	methods:{
      showContent(){
            
            this.$emit('content_ld_flag_false')
            var module_id=this.$route.params.module_id
          axios.get(this.$store.state.apiUrl+'/module_details',{
              params:{
                  id_module:'m'+module_id,
                  id_language:this.$store.state.companyData['id_language'],
                  id_company:this.$store.state.companyData['id_company'],
                  id_eap:this.$store.state.companyData['id_eap']                  
              }
          })
          .then(response => {
                response = response.data
                //console.log(response);
                this.main_content = response;
                this.$emit('content_ld_flag_changed');               
                this.$nextTick(function () {
                })
              
          })
          .catch(() => {
                this.main_content = []
          });
      }

    }
};
</script>
<style scoped>
.content-top-btm-space{
    padding: 55px 0;
}
.btn-primary{
    background-color: #7f867917 !important;	
}
.view-img{
    display: inline-block !important;
}		
.card-footer {
    padding: 0 0 0 0;
    background-color:transparent;
    
}
.card{
	background-repeat: no-repeat;
  background-size: cover;
  text-align: center;
	
}
.back-light{
	background-color: rgba(0, 0, 0, 0.45);
}
.list-group-item {
    background-color: #ffffff0d !important;
    border: 1px solid rgba(0, 0, 0, 0.11) !important;
    color: #fffffff0;
}

</style>
